module.exports = __webpack_public_path__ + "static/media/Logo3.a3f24cfb.png";